export function pluralize(text: string, data: string) {
  if (data === '1') return text
  return `${text}s`
}
